export const ActionTypes = {

  LOCATION_CHANGE: '@@router/LOCATION_CHANGE',

  CLEAR_STATE: 'CLEAR_STATE',
};
